import React from 'react';
import '../styles/shikki-page.css';

const ShikkiOverlay = ({ onClose }) => {
  return (
    <div className="shikki-page" onClick={onClose}>
      <div className="shikki-content">
        <h1 className="shikki-title">🌹 Shikki 🦋</h1>
        <p className="shikki-message">You discovered the secret garden...</p>
        <p className="shikki-hint">(Click anywhere to close)</p>
        
        {/* Decorative butterflies */}
        <div className="floating-butterflies">
          {[...Array(5)].map((_, i) => (
            <div key={i} className={`floating-butterfly butterfly-${i + 1}`}>
              🦋
            </div>
          ))}
        </div>
        
        {/* Decorative roses */}
        <div className="floating-roses">
          {[...Array(3)].map((_, i) => (
            <div key={i} className={`floating-rose rose-${i + 1}`}>
              🌹
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ShikkiOverlay;
